import { useEffect, useState } from "react";
import { GlobalTable } from "../../../global/components/GlobalTable";
import { useNavigate, useSearchParams } from "react-router-dom";
import useGet from "../../../global/hooks/useGet";
import { LicenseColumns } from "./Columns";
import ConfirmModal from "../../../global/components/ConfirmModal";
import useDelete from "../../../global/hooks/useDelete";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import { LicenseFilter } from "../Components/FilterComponent";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";

const initialFilterState = {
  LicenseNo: "",
  LicenseName: "",
  // LicenseType: "",
  Product: null,
  Model: null,
  // OldModel: "",
  SiteType: null,
  Type: "",
  // OldType: "",
  // OemName: "",
};

export const License = () => {
  const [hoveredRow, setHoveredRow] = useState(null);
  // const [allData, setAllData] = useState([]); // ✅ All data
  const [listData, setListData] = useState([]);
  const [params, setParams] = useSearchParams({
    limit: 10,
    sort_by: "LicenseNo",
    order: "desc",
  });
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //

  const initialPagination = {
    current: parseInt(modParams.page) || 1,
    pageSize: parseInt(modParams.limit) || 10,
    total: 0,
  }; //
  const [pagination, setPagination] = useState(initialPagination);
  const [filter, setFilter] = useState(initialFilterState);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filterNoValueText, setFilterNoValueText] = useState("");
  const [showModal, setShowModal] = useState(false);

  // const [searchValueExt, setSearchValueExt] = useState("");

  const navigate = useNavigate();

  const breadcrumbItems = [
    {
      label: "License",
      href: "/license",
    },
  ];

  const query = new URLSearchParams(params);
  // Remove unwanted keys
  query.delete("pageSize");
  query.delete("total");
  query.delete("current");
  const updatedQuery = query.toString();

  const url = updatedQuery
    ? `${process.env.REACT_APP_API_URL}/api/licenses/?${updatedQuery}`
    : `${process.env.REACT_APP_API_URL}/api/licenses/`;

  const { data, loading, error, refetch } = useGet(url);
  // console.log(data, " data from license api");
  const deleteUrl = `${process.env.REACT_APP_API_URL}/api/licenses/bulk-delete/`;
  // selectedRowKeys.length > 1
  //   ? (deleteUrl = `${process.env.REACT_APP_API_URL}/api/licenses/delete/`)
  //   : (deleteUrl = `${process.env.REACT_APP_API_URL}/api/licenses/delete/${selectedRowKeys}/`);

  const {
    data: deletedData,
    loading: deletedDataLoading,
    error: deletedDataError,
    // deleteData,
    deleteMultiple,
  } = useDelete(deleteUrl);

  const optionUrl = `${process.env.REACT_APP_API_URL}/api/licenses/options/`;

  const {
    data: optionData,
    loading: optionDataLoading,
    error: optionDataError,
  } = useGet(optionUrl);

  useEffect(() => {
    const matchedFilter = {};
    for (const key in initialFilterState) {
      if (modParams[key] !== undefined) {
        matchedFilter[key] = modParams[key];
      }
    }

    setFilter((prev) => ({
      ...prev,
      ...matchedFilter,
    }));
  }, []); //

  // ✅ Client-side pagination
  // const paginate = (data, page, pageSize) => {
  //   const startIndex = (page - 1) * pageSize;
  //   return data.slice(startIndex, startIndex + pageSize);
  // };

  // const applyFilterAndPaginate = (
  //   rawData,
  //   filterObj,
  //   page = 1,
  //   pageSize = 10,
  //   sort_by = null,
  //   order = null
  // ) => {
  //   let filtered = [...rawData];

  //   // Filtering
  //   if (filterObj.LicenseNo) {
  //     filtered = filtered
  //       .filter((item) => String(item.LicenseNo).includes(filterObj.LicenseNo))
  //       .sort((a, b) => {
  //         const aStr = String(a.LicenseNo);
  //         const bStr = String(b.LicenseNo);
  //         const query = filterObj.LicenseNo;

  //         const aStarts = aStr.startsWith(query);
  //         const bStarts = bStr.startsWith(query);
  //         if (aStarts && !bStarts) return -1;
  //         if (!aStarts && bStarts) return 1;

  //         const aDist = Math.abs(Number(aStr) - Number(query));
  //         const bDist = Math.abs(Number(bStr) - Number(query));
  //         return aDist - bDist;
  //       });
  //   }

  //   if (filterObj.LicenseName) {
  //     filtered = filtered
  //       .filter((item) =>
  //         String(item.LicenseName)
  //           .toLowerCase()
  //           .includes(filterObj.LicenseName.toLowerCase())
  //       )
  //       .sort((a, b) => {
  //         const aStr = String(a.LicenseName).toLowerCase();
  //         const bStr = String(b.LicenseName).toLowerCase();
  //         const query = filterObj.LicenseName.toLowerCase();

  //         const aStarts = aStr.startsWith(query);
  //         const bStarts = bStr.startsWith(query);

  //         if (aStarts && !bStarts) return -1;
  //         if (!aStarts && bStarts) return 1;

  //         return aStr.localeCompare(bStr);
  //       });
  //   }
  //   if (filterObj.ProductNo) {
  //     filtered = filtered
  //       .filter((item) => String(item.ProductNo).includes(filterObj.ProductNo))
  //       .sort((a, b) => {
  //         const aStr = String(a.ProductNo);
  //         const bStr = String(b.ProductNo);
  //         const query = filterObj.ProductNo;

  //         const aStarts = aStr.startsWith(query);
  //         const bStarts = bStr.startsWith(query);
  //         if (aStarts && !bStarts) return -1;
  //         if (!aStarts && bStarts) return 1;

  //         const aDist = Math.abs(Number(aStr) - Number(query));
  //         const bDist = Math.abs(Number(bStr) - Number(query));
  //         return aDist - bDist;
  //       });
  //   }
  //   if (filterObj.ModelNo) {
  //     filtered = filtered
  //       .filter((item) => String(item.ModelNo).includes(filterObj.ModelNo))
  //       .sort((a, b) => {
  //         const aStr = String(a.ModelNo);
  //         const bStr = String(b.ModelNo);
  //         const query = filterObj.ModelNo;

  //         const aStarts = aStr.startsWith(query);
  //         const bStarts = bStr.startsWith(query);
  //         if (aStarts && !bStarts) return -1;
  //         if (!aStarts && bStarts) return 1;

  //         const aDist = Math.abs(Number(aStr) - Number(query));
  //         const bDist = Math.abs(Number(bStr) - Number(query));
  //         return aDist - bDist;
  //       });
  //   }

  //   // if (filterObj.OemNo) {
  //   //   filtered = filtered
  //   //     .filter((item) => String(item.OemNo).includes(filterObj.OemNo))
  //   //     .sort((a, b) => {
  //   //       const aStr = String(a.OemNo);
  //   //       const bStr = String(b.OemNo);
  //   //       const query = filterObj.OemNo;

  //   //       const aStarts = aStr.startsWith(query);
  //   //       const bStarts = bStr.startsWith(query);
  //   //       if (aStarts && !bStarts) return -1;
  //   //       if (!aStarts && bStarts) return 1;

  //   //       const aDist = Math.abs(Number(aStr) - Number(query));
  //   //       const bDist = Math.abs(Number(bStr) - Number(query));
  //   //       return aDist - bDist;
  //   //     });
  //   // }

  //   // 🔽 Sort after filtering
  //   if (sort_by && filtered.length) {
  //     filtered.sort((a, b) => {
  //       const aVal = a[sort_by];
  //       const bVal = b[sort_by];

  //       if (typeof aVal === "number" && typeof bVal === "number") {
  //         return order === "desc" ? bVal - aVal : aVal - bVal;
  //       }

  //       return order === "desc"
  //         ? String(bVal).localeCompare(String(aVal))
  //         : String(aVal).localeCompare(String(bVal));
  //     });
  //   }

  //   const paginated = paginate(filtered, page, pageSize);
  //   setListData(paginated);
  //   setPagination({
  //     current: page,
  //     pageSize: pageSize,
  //     total: filtered.length,
  //   });
  // };

  const paginationConfig = {
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: data?.count,
    showSizeChanger: true,
    pageSizeOptions: [10, 20, 50, 100],
    showTotal: (total, range) => `Total ${total} items ${range[0]}-${range[1]}`,
    onChange: (page, pageSize) => {
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
      });

      const updatedParams = {
        ...Object.fromEntries([...params.entries()]),
        limit: pageSize,
        page: page,
      };
      setParams(updatedParams);
    },
  };

  // useEffect(() => {
  //   if (data && !loading) {
  //     const mapped = data?.data?.map((el) => ({ ...el, key: el.LicenseNo }));
  //     setAllData(mapped);
  //   }
  // }, [data, loading]);

  // Separate effect when allData updates
  // useEffect(() => {
  //   if (allData.length) {
  //     applyFilterAndPaginate(
  //       allData,
  //       filter,
  //       pagination.current,
  //       pagination.pageSize,
  //       params.sort_by,
  //       params.order
  //     );
  //   }
  // }, [allData]);

  // useEffect(() => {
  //   applyFilterAndPaginate(
  //     allData,
  //     filter,
  //     pagination.current,
  //     pagination.pageSize,
  //     params.sort_by,
  //     params.order
  //   );
  // }, [params]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    // navigate(`/oemlist/${newSelectedRowKeys}`);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    fixed: true,
  };

  const onRow = (record) => {
    return {
      onClick: (event) => {
        navigate(`/license/info/${record?.LicenseNo}`);
      },
    };
  };

  const handleFilterChange = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value.replace(/['""`''""]/g, "");
    setFilter({ ...filter, [inputName]: inputValue });
  };

  const handleFilter = (e) => {
    const filterDict = {};
    for (const key in filter) {
      if (
        filter[key] !== null &&
        filter[key] !== "" &&
        filter[key] !== undefined
      ) {
        filterDict[key] = filter[key];
      }
    }
    const isEmpty = JSON.stringify(filterDict) === "{}";

    if (isEmpty) {
      setFilterNoValueText("No value exists!");
      handleReset();
    } else {
      const params = {
        limit: 10,
        sort_by: "LicenseNo",
        order: "desc",
        ...filterDict,
      };
      setParams(params);
    }
  };

  // const onSearch = (searchObj) => {
  //   const updatedFilter = {
  //     ...filter,
  //     ...searchObj,
  //   };
  //   setFilter(updatedFilter);
  //   applyFilterAndPaginate(
  //     allData,
  //     updatedFilter,
  //     1,
  //     pagination.pageSize,
  //     params.sort_by,
  //     params.order
  //   );
  // };

  // const onReset = () => {
  //   const updatedFilter = {
  //     ...filter,
  //     ...initialSearchState,
  //   };
  //   setFilter(updatedFilter);
  //   applyFilterAndPaginate(
  //     allData,
  //     updatedFilter,
  //     1,
  //     pagination.pageSize,
  //     params.sort_by,
  //     params.order
  //   );
  // };

  // reset
  const handleReset = (e) => {
    // Reset the filter state to the initial state
    setFilter({
      current: 1,
      pageSize: 10,
      total: 0,
    }); //
    setPagination({
      current: 1,
      pageSize: 10,
      total: 0,
    }); //
    const params = {
      limit: 10,
      sort_by: "LicenseNo",
      order: "desc",
    };
    setParams(params);
    refetch();
  };

  const onDeleteConfirm = async () => {
    try {
      // if (selectedRowKeys.length === 1) {
      //   await deleteData();
      // } else {
      await deleteMultiple({ ids: selectedRowKeys });

      // }
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
    setSelectedRowKeys([]);
  };
  // console.log(deletedData && !deletedDataError);
  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      refetch();
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong"
      );
    }
  }, [deletedData, deletedDataError]);

  useEffect(() => {
    if (data && !loading) {
      const newData = data?.data?.map((el) => ({
        ...el,
        key: el?.LicenseNo,
      }));
      setListData(newData);
    }
  }, [data, loading]);

  return (
    <div>
      <div className="pb-4 -mt-4 pt-[6px]">
        <CommonBreadcrumb breadcrumbItems={breadcrumbItems} />
      </div>
      <div className="p-4 bg-white rounded-[4px] border border-gray-200">
        <LicenseFilter
          filter={filter}
          handleFilterChange={handleFilterChange}
          handleFilter={handleFilter}
          handleReset={handleReset}
          setShowModal={setShowModal}
          selectedRowKeys={selectedRowKeys}
          setFilter={setFilter}
          // onSearch={onSearch}
          // onReset={onReset}
          // searchValueExt={searchValueExt}
          // setSearchValueExt={setSearchValueExt}
          optionData={optionData}
        />
        <ConfirmModal
          showModal={showModal}
          setShowModal={setShowModal}
          onDeleteConfirm={onDeleteConfirm}
          setSelectedRowKeys={setSelectedRowKeys}
        />
        <GlobalTable
          columns={LicenseColumns(
            hoveredRow,
            setShowModal,
            setSelectedRowKeys,
            setParams,
            params,
            optionData
          )}
          dataSource={listData}
          rowSelection={rowSelection}
          pagination={paginationConfig}
          onRow={(record, rowIndex) => {
            return {
              onMouseEnter: () => setHoveredRow(rowIndex),
              onMouseLeave: () => setHoveredRow(null),
              ...onRow?.(record, rowIndex),
            };
          }}
          loading={loading}
        />
      </div>
    </div>
  );
};
